<template lang="pug">
include /mixins

+b.education-form
  +e.content
    validation-provider(
      v-slot="{ errors, validate }"
      :name='name'
      :bails='false'
      :ref='`${name}_valid`'
      :rules='rules'
    )
      div.relative
        input(
          type='hidden',
          :vid='name'
          :name='name'
          :ref='name'
          v-model='selectedValue'
        )
        +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
        v-selection-controller(
          :options='educationLevels'
          :multiple='false',
          :key-getter="$options.keyGetter",
          v-model='selectedValue'
          v-slot="{ options, value: model, change }"
        )
          +b.g-row--appearance_spaced
            +b.g-cell.g-cols(v-for='{ value } in options')
              +b.tt-space_mt--3.tt-space_ml--3
                +b.d-control-static-input--appearance_inline.TAG(
                  :rules='{ required: { allowFalse: true } }',
                  :tag='"input"'
                  :input-label='value.label'
                  :key='`key_${name}${value.value}`'
                  v-model='model'
                  :checked.props='model[0] && model[0].value == value.value'
                  :id='`level_${name}_${value.value}`'
                  :ref='`level_${name}_${value.value}`'
                  @change='change(value); setValue(value)'
                  type='radio'
                  :name='`radio_${name}`'
                )
                label.input-group__input(
                  :for='`level_${name}_${value.value}`'
                ) {{ value.label }}
    +e.input.tt-space_mt--5(
      v-if='selectedValue && selectedValue.has_input'
    )
      d-control-textarea(
        :input-label='inputLabel'
        key='comment'
        v-model='comment'
        class='is-textarea'
        ref='comment'
        name='comment'
        rows='5'
        @input='$emit("additional", {[additional_name]: comment})'
      )
</template>

<script>

import TicketManagementGallery from '@app/TicketManagement/Gallery'

import FileLoader from '@app/TicketManagement/FileLoader'

export default {
  name: 'CustomRadioSelect',
  keyGetter: x => `${x.value}`,
  props: {
    name: {
      default: 'medical_education_level',
    },
    inputLabel: {
    },
    additional_name: {},
    value: {
      type: Object,
      default: () => null,
    },
    form: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    FileLoader,
    TicketManagementGallery,
  },
  data() {
    return {
      file_name: 'education_documents',
      comment: '',
      educationLevels: [
        {
          value: 'yes',
          label: this._('Да'),
          required: true,
          has_input: true,
        },
        {
          value: 'no',
          label: this._('Нет'),
          required: true,
          has_input: false,
        },
        {
          value: 'want',
          label: this._('Нет, но хочу'),
          required: true,
          has_input: true,
        },
      ],
      selectedValue: null,
      rules: { required: false },
    }
  },
  watch: {
    value: {
      handler(nval, oval) {
        this.selectedValue = nval
      },
      immediate: true,
    },
    form: {
      handler(nval, oval) {
        const comment = nval[this.additional_name]
        console.log(comment, '===========');
        this.comment = comment || ''
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if (!this.selectedValue) {
      this.$emit('input', this.educationLevels[0])
    }
  },
  methods: {
    setValue(value) {
      this.selectedValue = value
      this.$emit('input', value)
    },
  },
}
</script>
